import { StoreState } from "../../models/states/StoreState";
import { VariableErrorModel } from "../VariableErrorModel";
import { makeMentionsSelector } from "../../redux/selectors/mentions";

const maxOpenEndLengthKey = "MaxOpenEndLength";
const errorKey = "InvalidCharactersMax";

export default function openEndMaximumLength(variable) {
    const { name: variableName, choiceList } = variable;
    const mentionsSelector = makeMentionsSelector(variableName);

    return (getState: () => StoreState): VariableErrorModel => {
        const mentions = mentionsSelector(getState());

        const [maximumViolation] = mentions
            .map((mention) => {
                const { openEnd = "" } = mention;
                const { settings = {} } = choiceList.find(
                    (choice) => choice.value === mention.value,
                );
                const maximum = settings[maxOpenEndLengthKey];
                return {
                    openEnd: openEnd.trim(),
                    maximum,
                };
            })
            .filter(({ openEnd, maximum }) => openEnd.length && maximum !== undefined)
            .map(({ openEnd, maximum }) => (openEnd.length > maximum ? maximum : undefined))
            .filter((maximum) => maximum !== undefined);

        if (maximumViolation) {
            return {
                variableName,
                error: { key: errorKey, args: { max: maximumViolation } },
            };
        }

        return null;
    };
}
